/** Tipo de mapa base de Google Maps (`google.maps.MapTypeId`) sin depender de que la API esté cargada. */
export enum MapType {
    Roadmap = 'roadmap',
    Hybrid = 'hybrid'
}
